<div class="flex items-center justify-center fixed top-0 bottom-0 left-0 right-0 z-50 bg-black-light">
	<p-progressSpinner ariaLabel="loading" strokeWidth="5" />
</div>